(function () {
  'use strict';

  // Bail gracefully if the config element is missing
  var configEl = document.querySelector('script[data-cashback-config]');
  if (!configEl) { return; }

  var data = {};
  try { data = JSON.parse(configEl.textContent || '{}'); } catch (e) { data = {}; }

  var CUSTOMER_ID = data.customer_id ? String(data.customer_id) : null;
  var BACKEND_ROOT = (data.backend_root || '').replace(/\/$/, '');
  var WALLET_BALANCE = Number(data.wallet_balance || 0);
  var WALLET_CURRENCY = data.wallet_currency || 'USD';
  var WALLET_CAP_PERCENT = Number(data.wallet_cap_percent || 0.25);
  var MIN_DISCOUNT_AMOUNT = Number(data.min_discount_amount || 0.50);
  var ELIGIBLE_VARIANT_IDS = Array.isArray(data.eligible_variant_ids)
    ? data.eligible_variant_ids.map(function (id) { return Number(id); })
    : [];

  var CBK_CONTAINER_ID = 'cbk-container';
  var CBK_TEMPLATE_ID = 'cbk-toggle-template';
  var LOYALTY_INFO_URL = 'https://13c.wine/pages/loyalty-program';

  var selectedDiscountType = null;
  var selectedDiscountCode = null;
  var cbkAmount = '';
  var cbkValidated = false;
  var cbkValidatedAmount = null;

  var isProcessing = false;

  function log(){ try{ console.debug.apply(console, arguments); } catch(e){} }
  function roundCents(n){ return Math.round(Number(n) * 100) / 100; }

  function showError(msg, yellowHighlight){
    var el = document.getElementById('discount-widget-error');
    if (el) {
      el.classList.toggle('discount-widget-error--yellow', !!yellowHighlight);
      el.style.display = 'block';
      el.textContent = msg || 'Unable to apply loyalty benefits right now.';
    }
  }

  function clearError(){
    var el = document.getElementById('discount-widget-error');
    if (el) {
      el.classList.remove('discount-widget-error--yellow');
      el.style.display = 'none';
      el.textContent = '';
    }
  }

  function hideExpressButtons(){
    var nodes = document.querySelectorAll('.shopify-payment-button, .additional-checkout-buttons');
    Array.prototype.forEach.call(nodes, function (el) {
      el.style.display = 'none';
      el.setAttribute('aria-hidden', 'true');
    });
  }

  function getCheckedRadio(){
    var r = document.querySelector('#discount-code-group input[type="radio"][name="cart-discount-choice"]:checked');
    return r ? (r.value || '') : '';
  }

  function clearAllRadios(){
    var radios = document.querySelectorAll('#discount-code-group input[type="radio"][name="cart-discount-choice"]');
    Array.prototype.forEach.call(radios, function(r){ r.checked = false; });
  }

  function clearCashbackUI(){
    var checkbox = document.getElementById('cbk-toggle');
    var amountContainer = document.getElementById('cbk-amount-container');
    var amtInput = document.getElementById('cbk-requested-amount');
    var inputError = document.getElementById('cbk-input-error');
    var eligibilityNote = document.getElementById('cbk-eligibility-note');

    if (checkbox) checkbox.checked = false;
    if (amountContainer) amountContainer.style.display = 'none';
    if (eligibilityNote) eligibilityNote.style.display = 'none';
    if (amtInput) amtInput.value = '';
    if (inputError) {
      inputError.style.display = 'none';
      inputError.textContent = '';
    }
    cbkAmount = '';
    cbkValidated = false;
    cbkValidatedAmount = null;
  }

  function renderAppliedDiscount(code){
  }

  function renderAppliedDiscount(code){
    var container = document.getElementById('applied-discount-container');
    var codeEl = document.getElementById('applied-discount-code');
    if (!container || !codeEl) return;

    if (code) {
      codeEl.textContent = code;
      container.style.display = '';
    } else {
      codeEl.textContent = '';
      container.style.display = 'none';
    }
  }

  function hideCashbackResultContainers(){
    var appliedContainer = document.getElementById('applied-discount-container');
    var priceDisplay = document.getElementById('cbk-price-display');
    if (appliedContainer) appliedContainer.style.display = 'none';
    if (priceDisplay) priceDisplay.style.display = 'none';
  }

  async function validateCashback(cartLines, requestedAmount){
    if (!CUSTOMER_ID) return null;

    try {
      var payload = {
        customer_id: CUSTOMER_ID,
        cart_lines: cartLines
      };
      if (requestedAmount != null) {
        payload.requested_amount = requestedAmount;
      }

      var res = await fetch(BACKEND_ROOT + '/api/validate-cashback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!res.ok) throw new Error('validate-cashback failed');
      return await res.json();
    } catch (e) {
      log('[cbk] validate-cashback error', e);
      return null;
    }
  }

  // Read the customer-selected delivery window from the page widgets
  // (rendered by a separate Shopify app). The date input lives inside
  // .bcdp-calendar-container and the time input inside
  // .bcdp-time-container. Values come back pre-formatted, e.g.
  //   date: "Jul 21, 2026"
  //   time: "3:00 PM - 4:00 PM"
  // The backend treats these as optional — empty/whitespace strings
  // are dropped from the draft order note + note_attributes.
  function readDeliveryWindow(){
    var dateEl = document.querySelector('.bcdp-calendar-container > div:nth-child(1) > input:nth-child(1)');
    var timeEl = document.querySelector('.bcdp-time-container > div:nth-child(1) > input:nth-child(1)');
    var deliveryDate = dateEl ? (dateEl.value || '').trim() : '';
    var deliveryTime = timeEl ? (timeEl.value || '').trim() : '';
    return { deliveryDate: deliveryDate, deliveryTime: deliveryTime };
  }

  // Optional free-text order/delivery note. The theme renders the cart note
  // textarea (#cartSpecialInstructions) when cart notes are enabled, and the
  // delivery app may render its own note field. Forward whichever exists so
  // the backend can place it at the top of the order note.
  function readOrderNote(){
    var selectors = ['#cartSpecialInstructions', 'textarea[name="note"]', '#cbk-order-note', '#order-note'];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && el.value && el.value.trim()) return el.value.trim();
    }
    return '';
  }

  async function createDraftOrder(cartLines, requestedAmount, discountType){
    if (!CUSTOMER_ID) return null;

    var delivery = readDeliveryWindow();
    var orderNote = readOrderNote();
    var body = {
      customer_id: CUSTOMER_ID,
      cart_lines: cartLines,
      requested_amount: requestedAmount,
      discount_type: discountType,
      // sales_channel identifies the order source that gets written into the
      // draft order notes.
      sales_channel: '13C Website'
    };
    // delivery_date / delivery_time are optional on the backend. Only
    // forward them when the customer has picked values so the draft
    // order note + note_attributes stay clean when no window is set.
    if (delivery.deliveryDate) body.delivery_date = delivery.deliveryDate;
    if (delivery.deliveryTime) body.delivery_time = delivery.deliveryTime;
    // Optional cart/delivery note, placed at the top of the order note.
    if (orderNote) body.note = orderNote;

    try {
      var res = await fetch(BACKEND_ROOT + '/api/create-draft-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });

      if (!res.ok) throw new Error('create-draft-order failed');
      return await res.json();
    } catch (e) {
      log('[cbk] create-draft-order error', e);
      return null;
    }
  }

  function clearSelection(){
    clearAllRadios();
    clearCashbackUI();
    selectedDiscountType = null;
    selectedDiscountCode = null;
    renderAppliedDiscount('');
    clearError();
    hideExpressButtons();
    var priceDisplay = document.getElementById('cbk-price-display');
    if (priceDisplay) priceDisplay.style.display = 'none';
    updateShopifyCartTotal(null);
  }

  function isEligibleCartItem(item) {
    if (!item) return false;
    if (!ELIGIBLE_VARIANT_IDS || !ELIGIBLE_VARIANT_IDS.length) return false;

    var variantId = Number(item.variant_id || 0);
    if (ELIGIBLE_VARIANT_IDS.indexOf(variantId) === -1) return false;

    var unitPrice = Number(item.final_price != null ? item.final_price : (item.price || 0));
    var compareAt = Number(item.compare_at_price || 0);
    var original = Number(item.original_price || (item.price || 0));

    var onSale = false;
    if (compareAt > 0 && compareAt > unitPrice) onSale = true;
    if (!onSale && unitPrice < original) onSale = true;
    if (onSale) return false;

    return true;
  }

  function updateBalanceLabel(balance, currency){
    var el = document.getElementById('cbk-balance-label');
    if (!el) return;
    try { el.textContent = '(wallet: ' + Number(balance || 0).toFixed(2) + ' ' + (currency || 'USD') + ')'; } catch(e){}
  }

  async function getLiveCart(){
    try {
      var res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('cart fetch failed');
      return await res.json();
    } catch (e) {
      log('[cbk] getLiveCart error', e);
      return null;
    }
  }

  async function getCartLinesForBackend(){
    var cart = await getLiveCart();
    if (!cart || !cart.items || !cart.items.length) return [];

    return cart.items
      .filter(function(item) {
        return isEligibleCartItem(item);
      })
      .map(function(item) {
        return {
          line_key: String(item.key || ('variant:' + String(item.variant_id || ''))),
          variant_id: Number(item.variant_id || 0),
          quantity: Number(item.quantity || 0),
          price: ((item.final_price != null ? item.final_price : item.price) / 100).toFixed(2)
        };
      });
  }

  async function updateCbkPriceDisplay(){
    var checkbox = document.getElementById('cbk-toggle');
    var priceDisplay = document.getElementById('cbk-price-display');
    var originalPriceEl = document.getElementById('cbk-original-price');
    var discountAmountEl = document.getElementById('cbk-discount-amount');
    var newPriceEl = document.getElementById('cbk-new-price');

    var hasCbk = checkbox && checkbox.checked && cbkAmount;
    var requestedAmount = roundCents(parseFloat(cbkAmount || '0'));
    var isAppliedAndValidated = !!(cbkValidated && cbkValidatedAmount === cbkAmount);

    if (!hasCbk || requestedAmount <= 0 || !isAppliedAndValidated) {
      if (priceDisplay) priceDisplay.style.display = 'none';
      // Reset Shopify cart total
      updateShopifyCartTotal(null);
      return;
    }

    var cart = await getLiveCart();
    if (!cart) return;

    var cartTotal = (cart.total_price || 0) / 100;
    var newTotal = Math.max(0, cartTotal - requestedAmount);

    // Update custom price display
    if (priceDisplay && originalPriceEl && discountAmountEl && newPriceEl) {
      originalPriceEl.textContent = cartTotal.toFixed(2) + ' ' + WALLET_CURRENCY;
      discountAmountEl.textContent = '- ' + requestedAmount.toFixed(2) + ' ' + WALLET_CURRENCY;
      newPriceEl.textContent = newTotal.toFixed(2) + ' ' + WALLET_CURRENCY;
      priceDisplay.style.display = 'block';
    }

    // Update actual Shopify cart total
    updateShopifyCartTotal({ original: cartTotal, discount: requestedAmount, newTotal: newTotal });
  }

  function updateShopifyCartTotal(prices){
    // Find the Shopify cart total element - the strong element inside .cart__total
    var cartTotalEl = document.querySelector('.cart__details .cart__total strong.text-size--heading, .cart__subtotal-widget .cart__total strong');
    if (!cartTotalEl) {
      // Try alternative selectors
      cartTotalEl = document.querySelector('#AjaxCartSubtotal .cart__total strong, #AjaxCartSubtotal .cart__subtotal-widget .cart__total strong');
    }

    // Find original price display element
    var originalPriceContainer = document.getElementById('cbk-original-price-container');

    if (!prices) {
      // Reset: restore original price if we modified it
      if (originalPriceContainer) {
        originalPriceContainer.remove();
      }
      if (cartTotalEl) {
        cartTotalEl.style.textDecoration = '';
        cartTotalEl.style.color = '';
      }
      return;
    }

    if (!cartTotalEl) return;

    // Create or update original price display
    if (!originalPriceContainer) {
      originalPriceContainer = document.createElement('span');
      originalPriceContainer.id = 'cbk-original-price-container';
      originalPriceContainer.style.cssText = 'display:block;text-decoration:line-through;color:#999;font-size:0.9rem;margin-bottom:2px;';
      cartTotalEl.parentNode.insertBefore(originalPriceContainer, cartTotalEl);
    }

    // Show original price crossed out
    originalPriceContainer.textContent = 'Original: ' + prices.original.toFixed(2) + ' ' + WALLET_CURRENCY;

    // Update the main total to show discounted price
    cartTotalEl.textContent = prices.newTotal.toFixed(2) + ' ' + WALLET_CURRENCY;
    cartTotalEl.style.textDecoration = 'none';
    cartTotalEl.style.color = '#000000';
  }

  async function handleCheckoutRedirect(){
    try {
      if (isProcessing) return;
      isProcessing = true;

      clearError();

      var checkbox = document.getElementById('cbk-toggle');
      var radio = getCheckedRadio();
      var amountInput = document.getElementById('cbk-requested-amount');
      var hasCbkInputValue = !!(amountInput && (amountInput.value || '').trim());

      var hasCbk = checkbox && checkbox.checked && cbkAmount;
      var hasTag = radio;

      if (checkbox && checkbox.checked && hasCbkInputValue && (!cbkValidated || cbkValidatedAmount !== cbkAmount)) {
        showError('Please click Apply to validate cashback before checkout.');
        isProcessing = false;
        return;
      }

      if (!hasCbk && !hasTag) {
        window.location.href = '/checkout';
        return;
      }

      var cartLines = await getCartLinesForBackend();
      var requestedAmount = hasCbk ? roundCents(parseFloat(cbkAmount)) : null;
      var discountType = hasCbk ? 'cbk_wallet' : radio;

      if (hasCbk && cartLines.length === 0) {
        showError('No eligible items in cart for cashback.', true);
        isProcessing = false;
        return;
      }

      if (hasCbk && requestedAmount < MIN_DISCOUNT_AMOUNT) {
        showError('Minimum cashback amount is ' + MIN_DISCOUNT_AMOUNT.toFixed(2) + '.');
        isProcessing = false;
        return;
      }

      try {
        var result = await createDraftOrder(cartLines, requestedAmount, discountType);

        if (!result || !result.invoice_url) {
          showError(result && result.message ? result.message : 'Failed to create draft order.');
          isProcessing = false;
          return;
        }

        window.location.href = result.invoice_url;

      } catch (err) {
        console.error('[cbk] checkout redirect failed', err);
        showError('Failed to process discount. Try again.');
        isProcessing = false;
      }
    } catch (err) {
      console.error('[cbk] handleCheckoutRedirect fatal error', err);
      isProcessing = false;
      showError('Something went wrong. Please try again.');
    }
  }

  function attachRadioHandlers(){
    var radios = document.querySelectorAll('#discount-code-group input[type="radio"][name="cart-discount-choice"]');
    Array.prototype.forEach.call(radios, function (r) {
      if (r.__cbkRadioBound) return;
      r.__cbkRadioBound = true;

      r.addEventListener('change', function () {
        var cbk = document.getElementById('cbk-toggle');
        if (cbk && cbk.checked) {
          cbk.checked = false;
          clearCashbackUI();
        }

        var checked = getCheckedRadio();
        if (checked) {
          selectedDiscountType = checked;
          renderAppliedDiscount(checked);
        } else {
          selectedDiscountType = null;
          renderAppliedDiscount('');
        }
      });
    });
  }

  function bindToggleBehavior(){
    var checkbox = document.getElementById('cbk-toggle');
    if (!checkbox || checkbox.__cbkBound) return;

    checkbox.__cbkBound = true;
    checkbox.checked = false;

    var amountContainer = document.getElementById('cbk-amount-container');
    var amtInput = document.getElementById('cbk-requested-amount');
    var inputError = document.getElementById('cbk-input-error');
    var disabledNote = document.getElementById('cbk-disabled-note');
    var toggleLabelText = document.getElementById('cbk-toggle-label-text');
    var eligibilityNote = document.getElementById('cbk-eligibility-note');

    updateBalanceLabel(WALLET_BALANCE, WALLET_CURRENCY);

    if (WALLET_BALANCE < MIN_DISCOUNT_AMOUNT) {
      checkbox.disabled = true;
      disabledNote.style.display = 'inline';
      disabledNote.textContent = '(insufficient cashback)';
      try { toggleLabelText.textContent = 'Use cashback credits (unavailable)'; } catch(e){}
    }

    function onToggleOn(){
      clearAllRadios();
      clearError();
      renderAppliedDiscount('');
      cbkValidated = false;
      cbkValidatedAmount = null;

      if (WALLET_BALANCE < MIN_DISCOUNT_AMOUNT) {
        checkbox.checked = false;
        amountContainer.style.display = 'none';
        if (eligibilityNote) eligibilityNote.style.display = 'none';
        showError('Insufficient cashback available to apply (min ' + MIN_DISCOUNT_AMOUNT.toFixed(2) + ').');
        return;
      }

      amountContainer.style.display = 'flex';
      if (eligibilityNote) eligibilityNote.style.display = 'block';
      selectedDiscountType = 'cbk_wallet';
      selectedDiscountCode = null;
      updateCbkPriceDisplay();
    }

    function onToggleOff(){
      amountContainer.style.display = 'none';
      if (eligibilityNote) eligibilityNote.style.display = 'none';
      if (inputError) {
        inputError.style.display = 'none';
        inputError.textContent = '';
      }
      cbkAmount = '';
      cbkValidated = false;
      cbkValidatedAmount = null;

      if (selectedDiscountType === 'cbk_wallet') {
        selectedDiscountType = null;
        selectedDiscountCode = null;
      }
      updateCbkPriceDisplay();
    }

    function validateLive(){
      var raw = (amtInput.value || '').trim();

      if (!raw) {
        if (inputError) {
          inputError.style.display = 'none';
          inputError.textContent = '';
        }
        cbkAmount = '';
        cbkValidated = false;
        cbkValidatedAmount = null;
        return;
      }

      var parsed = parseFloat(raw);
      if (isNaN(parsed) || parsed <= 0) {
        if (inputError) {
          inputError.textContent = 'Enter a valid amount';
          inputError.style.display = 'block';
        }
        return;
      }

      var rounded = roundCents(parsed);

      if (rounded < MIN_DISCOUNT_AMOUNT) {
        if (inputError) {
          inputError.textContent = 'Minimum is ' + MIN_DISCOUNT_AMOUNT.toFixed(2);
          inputError.style.display = 'block';
        }
        return;
      }

      if (rounded > WALLET_BALANCE) {
        if (inputError) {
          inputError.replaceChildren();
          inputError.insertAdjacentHTML('beforeend', 'Exceeds wallet balance (' + WALLET_BALANCE.toFixed(2) + ') <a href="' + LOYALTY_INFO_URL + '" target="_blank" rel="noopener">learn more?</a>');
          inputError.style.display = 'block';
        }
        return;
      }

      if (inputError) {
        inputError.style.display = 'none';
        inputError.textContent = '';
      }

      if (cbkValidated && cbkValidatedAmount !== raw) {
        cbkValidated = false;
        cbkValidatedAmount = null;
      }
      cbkAmount = raw;
    }

    checkbox.addEventListener('change', function () {
      clearError();
      if (checkbox.checked) onToggleOn();
      else onToggleOff();
    });

    amtInput.addEventListener('input', function () {
      var liveRaw = (amtInput.value || '').trim();
      if (!liveRaw || liveRaw !== cbkValidatedAmount) {
        cbkValidated = false;
        cbkValidatedAmount = null;
      }
      if (amtInput._debounce) clearTimeout(amtInput._debounce);
      amtInput._debounce = setTimeout(function(){
        validateLive();
        updateCbkPriceDisplay();
      }, 150);
    });

    var applyBtn = document.getElementById('cbk-apply-btn');
    if (applyBtn) {
      applyBtn.addEventListener('click', async function () {
        clearError();
        validateLive();
        if (inputError && inputError.style.display !== 'none') return;
        if (!checkbox || !checkbox.checked) {
          showError('Enable cashback before applying an amount.');
          return;
        }
        if (!cbkAmount) {
          showError('Enter a cashback amount before applying.');
          return;
        }

        var requestedAmount = roundCents(parseFloat(cbkAmount));
        var cartLines = await getCartLinesForBackend();

        if (!cartLines.length) {
          cbkValidated = false;
          cbkValidatedAmount = null;
          hideCashbackResultContainers();
          showError('No eligible items in cart for cashback.', true);
          return;
        }

        var validation = await validateCashback(cartLines, requestedAmount);
        if (!validation || !validation.valid) {
          cbkValidated = false;
          cbkValidatedAmount = null;
          hideCashbackResultContainers();
          showError(validation && validation.message ? validation.message : 'Cannot apply this cashback amount.');
          return;
        }

        if (requestedAmount > parseFloat(validation.allowed_max)) {
          cbkValidated = false;
          cbkValidatedAmount = null;
          hideCashbackResultContainers();
          showError('Max allowed is ' + parseFloat(validation.allowed_max).toFixed(2) + ' ' + WALLET_CURRENCY + '.');
          return;
        }

        cbkValidated = true;
        cbkValidatedAmount = cbkAmount;
        updateCbkPriceDisplay();
        renderAppliedDiscount('Cashback: ' + cbkAmount + ' ' + WALLET_CURRENCY);
      });
    }
  }

  function attachCancelButton(){
    var btn = document.getElementById('discount-cancel-button');
    if (!btn || btn.__cancelBound) return;
    btn.__cancelBound = true;
    btn.addEventListener('click', function () {
      clearSelection();
    });
  }

  function attachInterceptors(){
    var CHECKOUT_BTN_SELECTOR = "#CheckOut, [data-checkout-button], .cart__checkout, button[name='checkout'], a[href^='/checkout']";
    var EXPRESS_SELECTOR = ".shopify-payment-button, .additional-checkout-buttons, .shopify-payment-button__button";

    function attach(selector){
      var nodes = document.querySelectorAll(selector);
      Array.prototype.forEach.call(nodes, function (el) {
        if (el.__discountInterceptorAttached) return;
        el.__discountInterceptorAttached = true;
        el.addEventListener('click', function (e) {
          e.preventDefault();
          handleCheckoutRedirect();
        }, { passive: false });
      });
    }

    attach(CHECKOUT_BTN_SELECTOR);
    attach(EXPRESS_SELECTOR);

    var form = document.querySelector('form[action*="/cart"]');
    if (form && !form.__walletSubmitGuard) {
      form.__walletSubmitGuard = true;
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        handleCheckoutRedirect();
      }, { passive: false });
    }
  }

  function invalidateLoyaltyState(){
    var checkbox = document.getElementById('cbk-toggle');
    if (checkbox && checkbox.checked) {
      clearSelection();
    } else {
      var radio = getCheckedRadio();
      if (!radio) {
        clearSelection();
      }
    }
  }

  function attachMutationInvalidators(){
    if (document.__loyaltyMutationInvalidatorsBound) return;
    document.__loyaltyMutationInvalidatorsBound = true;

    document.addEventListener('click', function(e){
      var t = e.target;
      if (!t) return;

      if (
        t.closest('[data-cart-remove]') ||
        t.closest('a[href*="/cart/change"]') ||
        t.closest('button[name="minus"]') ||
        t.closest('button[name="plus"]') ||
        t.closest('.quantity__button') ||
        t.closest('.cart-remove') ||
        t.closest('form[action*="/cart/add"]')
      ) {
        invalidateLoyaltyState();
      }
    }, true);

    document.addEventListener('change', function(e){
      var t = e.target;
      if (!t) return;

      if (
        t.matches('input[name^="updates"]') ||
        t.matches('.quantity__input') ||
        t.matches('select[name^="updates"]')
      ) {
        invalidateLoyaltyState();
      }
    }, true);

    document.addEventListener('input', function(e){
      var t = e.target;
      if (!t) return;

      if (
        t.matches('input[name^="updates"]') ||
        t.matches('.quantity__input')
      ) {
        invalidateLoyaltyState();
      }
    }, true);

    document.addEventListener('submit', function(e){
      var form = e.target;
      if (!form || !(form instanceof HTMLFormElement)) return;

      if (form.matches('form[action*="/cart/add"]')) {
        invalidateLoyaltyState();
      }
    }, true);

    window.addEventListener('pageshow', function () {
      clearSelection();
    });
  }

  function ensureToggleExistsAndBind(){
    if (document.getElementById('cbk-toggle')) {
      return document.getElementById('cbk-toggle');
    }

    var main = document.getElementById(CBK_CONTAINER_ID);
    if (!main) {
      log('[cbk] insertion container not found');
      return null;
    }

    var tpl = document.getElementById(CBK_TEMPLATE_ID);
    if (!tpl) {
      log('[cbk] template missing');
      return null;
    }

    try {
      main.insertAdjacentHTML('beforeend', tpl.innerHTML);
    } catch (e) {
      log('[cbk] insert error', e);
      try {
        const temp = document.createElement('div');
        temp.innerHTML = tpl.innerHTML;
        main.append(...temp.childNodes);
      } catch (ee) { log('[cbk] fallback failed', ee); return null; }
    }

    bindToggleBehavior();
    return document.getElementById('cbk-toggle');
  }

  // ── Error Boundary ──────────────────────────────────────
  // Top-level safeguard: if the entire cashback subsystem
  // throws during init, show a user-visible fallback banner
  // in the discount widget area so customers know loyalty is
  // temporarily unavailable — but checkout itself keeps working.
  var ERROR_BOUNDARY_ID = 'cbk-error-boundary';

  function showFallbackBanner(msg){
    var container = document.getElementById('discount-code-group') ||
                    document.getElementById('cbk-container');
    if (!container) return;
    var existing = document.getElementById(ERROR_BOUNDARY_ID);
    if (existing) existing.remove();
    var banner = document.createElement('div');
    banner.id = ERROR_BOUNDARY_ID;
    banner.setAttribute('role', 'alert');
    banner.textContent = msg || 'Loyalty benefits temporarily unavailable.';
    banner.style.cssText = 'padding:8px 12px;margin:8px 0;background:#fff3cd;color:#856404;border:1px solid #ffc107;border-radius:4px;font-size:0.9rem;';
    container.parentNode.insertBefore(banner, container);
  }

  function removeFallbackBanner(){
    var el = document.getElementById(ERROR_BOUNDARY_ID);
    if (el) el.remove();
  }

  // ── Safeguard for all API calls ─────────────────────────
  // Each API function (validateCashback, createDraftOrder,
  // getLiveCart) already has its own per-function catch.
  // This post-init guard ensures uncaught rejections from
  // any async path trigger the fallback banner.
  window.addEventListener('unhandledrejection', function(evt){
    if (evt.reason && evt.reason.message &&
        (evt.reason.message.indexOf('cbk') !== -1 ||
         evt.reason.message.indexOf('cashback') !== -1 ||
         evt.reason.message.indexOf('validate-cashback') !== -1 ||
         evt.reason.message.indexOf('create-draft-order') !== -1)) {
      showFallbackBanner('Loyalty benefits temporarily unavailable.');
    }
  });

  // ── Init with Error Boundary ────────────────────────────
  (function init(){
    try {
      hideExpressButtons();
      attachRadioHandlers();
      attachInterceptors();
      attachCancelButton();
      attachMutationInvalidators();
      ensureToggleExistsAndBind();
      removeFallbackBanner();
    } catch (e) {
      log('[cbk] init error boundary caught', e);
      showFallbackBanner('Loyalty benefits temporarily unavailable.');
    }
  })();

})();
